'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileExceedsSizeLimit = undefined;

var _fileUploadsConstants = require('../constants/fileUploadsConstants');

var fileExceedsSizeLimit = exports.fileExceedsSizeLimit = function fileExceedsSizeLimit(file) {
  return file.size > _fileUploadsConstants.MAX_FILE_SIZE;
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/util/fileExceedsSizeLimit.js
// module id = 556
// module chunks = 2 3